import { render, staticRenderFns } from "./LichSuGiaiTriList.vue?vue&type=template&id=055b2a05"
import script from "./LichSuGiaiTriList.vue?vue&type=script&lang=js"
export * from "./LichSuGiaiTriList.vue?vue&type=script&lang=js"
import style0 from "./LichSuGiaiTriList.vue?vue&type=style&index=0&id=055b2a05&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports